let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");

let icon_map = {
  "onsite": "fa-users",
  "1": "fa-users",
  "virtual": "fa-video-camera",
  "web": "fa-video-camera",
  "2": "fa-video-camera",
  "phone": "fa-phone",
  "3": "fa-phone",
  "not set": "",
  "0": "",
  null: ""
};

module.exports = dd.createClass({
  render() {
    let {delivery_method} = this.props;

    if (!_.has(icon_map, delivery_method)) {
      return dd.span();
    }

    return dd.i({className: "fa " + icon_map[delivery_method]});
  }
});



// WEBPACK FOOTER //
// ./src/components/widgets/DeliveryMethodIcon.js